import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a3b3c676"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "dealer-query",
  class: "dealer_query-outer"
}
const _hoisted_2 = {
  id: "dealer-query",
  class: "dealer_query-wrapper"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Title", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Category", -1))
const _hoisted_5 = { class: "function-btn" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Reset")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Search")
const _hoisted_8 = { class: "dealer_query-data" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("View")
const _hoisted_10 = { class: "pagination-container d-f justify-e" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumb, { dataSource: [
      {
        name: 'Help Center Enquiry',
      },
    ] }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_a_space, {
          class: "dealer-query_form",
          direction: "vertical",
          size: _ctx.spaceSize
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createVNode(_component_a_input, {
              value: _ctx.question,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.question) = $event)),
              placeholder: "Please Input"
            }, null, 8, ["value"])
          ]),
          _: 1
        }, 8, ["size"]),
        _createVNode(_component_a_space, {
          class: "dealer-query_form",
          direction: "vertical",
          size: _ctx.spaceSize
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createVNode(_component_a_select, {
              value: _ctx.category,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.category) = $event)),
              ref: "select",
              placeholder: "Please Select",
              class: "sel-inp-size",
              allowClear: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryList, (item) => {
                  return (_openBlock(), _createBlock(_component_a_select_option, {
                    value: item.id,
                    key: item.id,
                    title: item.type
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.type), 1)
                    ]),
                    _: 2
                  }, 1032, ["value", "title"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }, 8, ["size"]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_a_space, {
            size: _ctx.spaceSize,
            direction: "horizontal"
          }, {
            default: _withCtx(() => [
              (_ctx.$btnPermissions('FAQ Enquiry Reset'))
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    onClick: _ctx.reset
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.$btnPermissions('FAQ Enquiry Search'))
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    type: "primary",
                    onClick: _ctx.handleSearch
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["size"])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_a_table, {
          class: "dealerManagementTable",
          rowClassName: 
          (record, index) => (index % 2 === 1 ? 'table-striped' : null)
        ,
          dataSource: _ctx.dataSource,
          columns: _ctx.columns,
          pagination: false,
          scroll: {
          x: _ctx.tableWidth,
          y: _ctx.colHeight,
        }
        }, {
          action: _withCtx(({ record }) => [
            _createElementVNode("span", null, [
              (_ctx.$btnPermissions('FAQ Enquiry View'))
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    type: "link",
                    onClick: ($event: any) => (_ctx.view(record.id))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["rowClassName", "dataSource", "columns", "scroll"]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_a_pagination, {
            "show-size-changer": "",
            "show-quick-jumper": "",
            total: _ctx.pagination.total,
            "show-total": (total) => `Total ${_ctx.pagination.total} items`,
            onChange: _ctx.pageChange,
            onShowSizeChange: _ctx.sizeChange,
            pageSize: _ctx.pagination.pageSize,
            "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pagination.pageSize) = $event)),
            pageIndex: _ctx.pagination.pageIndex,
            "onUpdate:pageIndex": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.pagination.pageIndex) = $event)),
            pageSizeOptions: ['10', '20', '30', '40', '50']
          }, {
            buildOptionText: _withCtx((props) => [
              _createElementVNode("span", null, _toDisplayString(props.value) + "/page", 1)
            ]),
            _: 1
          }, 8, ["total", "show-total", "onChange", "onShowSizeChange", "pageSize", "pageIndex"])
        ])
      ])
    ])
  ], 64))
}